import { gql } from '@apollo/client';

export const GET_FUNCIONES = gql`
    query GetFunciones {
        funciones {
            success
            error
            valorEsperado {
                idFuncion
                funcion
            }
        }
    }
`;